/**
 * 手机区号配置（支持国际化）
 * 数据结构：{ value: '+86', zh: '中国', en: 'China' }
 */
export const AREA_CODE_LIST = [
  // 中国地区
  { value: '+86', zh: '中国', en: 'China' },
  { value: '+852', zh: '中国香港', en: 'Hong Kong SAR' },
  { value: '+853', zh: '中国澳门', en: 'Macau SAR' },
  { value: '+886', zh: '中国台湾', en: 'Taiwan, China' },

  // 北美洲
  { value: '+1', zh: '美国/加拿大', en: 'United States/Canada' },
  { value: '+52', zh: '墨西哥', en: 'Mexico' },
  { value: '+501', zh: '伯利兹', en: 'Belize' },
  { value: '+502', zh: '危地马拉', en: 'Guatemala' },
  { value: '+503', zh: '萨尔瓦多', en: 'El Salvador' },
  { value: '+504', zh: '洪都拉斯', en: 'Honduras' },
  { value: '+505', zh: '尼加拉瓜', en: 'Nicaragua' },
  { value: '+506', zh: '哥斯达黎加', en: 'Costa Rica' },
  { value: '+507', zh: '巴拿马', en: 'Panama' },
  { value: '+1809', zh: '多米尼加', en: 'Dominican Republic' },
  { value: '+1876', zh: '牙买加', en: 'Jamaica' },
  { value: '+1246', zh: '巴巴多斯', en: 'Barbados' },
  { value: '+1268', zh: '安提瓜和巴布达', en: 'Antigua and Barbuda' },
  { value: '+1345', zh: '开曼群岛', en: 'Cayman Islands' },
  { value: '+1441', zh: '百慕大', en: 'Bermuda' },
  { value: '+1473', zh: '格林纳达', en: 'Grenada' },
  { value: '+1649', zh: '特克斯和凯科斯群岛', en: 'Turks and Caicos Islands' },
  { value: '+1671', zh: '关岛', en: 'Guam' },
  { value: '+1721', zh: '圣马丁岛', en: 'Sint Maarten' },
  { value: '+1787', zh: '波多黎各', en: 'Puerto Rico' },
  { value: '+1868', zh: '特立尼达和多巴哥', en: 'Trinidad and Tobago' },

  // 南美洲
  { value: '+55', zh: '巴西', en: 'Brazil' },
  { value: '+54', zh: '阿根廷', en: 'Argentina' },
  { value: '+56', zh: '智利', en: 'Chile' },
  { value: '+57', zh: '哥伦比亚', en: 'Colombia' },
  { value: '+51', zh: '秘鲁', en: 'Peru' },
  { value: '+58', zh: '委内瑞拉', en: 'Venezuela' },
  { value: '+593', zh: '厄瓜多尔', en: 'Ecuador' },
  { value: '+595', zh: '巴拉圭', en: 'Paraguay' },
  { value: '+598', zh: '乌拉圭', en: 'Uruguay' },
  { value: '+591', zh: '玻利维亚', en: 'Bolivia' },
  { value: '+592', zh: '圭亚那', en: 'Guyana' },
  { value: '+594', zh: '法属圭亚那', en: 'French Guiana' },
  { value: '+597', zh: '苏里南', en: 'Suriname' },

  // 欧洲
  { value: '+44', zh: '英国', en: 'United Kingdom' },
  { value: '+49', zh: '德国', en: 'Germany' },
  { value: '+33', zh: '法国', en: 'France' },
  { value: '+39', zh: '意大利', en: 'Italy' },
  { value: '+34', zh: '西班牙', en: 'Spain' },
  { value: '+351', zh: '葡萄牙', en: 'Portugal' },
  { value: '+31', zh: '荷兰', en: 'Netherlands' },
  { value: '+32', zh: '比利时', en: 'Belgium' },
  { value: '+41', zh: '瑞士', en: 'Switzerland' },
  { value: '+43', zh: '奥地利', en: 'Austria' },
  { value: '+46', zh: '瑞典', en: 'Sweden' },
  { value: '+47', zh: '挪威', en: 'Norway' },
  { value: '+45', zh: '丹麦', en: 'Denmark' },
  { value: '+358', zh: '芬兰', en: 'Finland' },
  { value: '+48', zh: '波兰', en: 'Poland' },
  { value: '+420', zh: '捷克', en: 'Czech Republic' },
  { value: '+421', zh: '斯洛伐克', en: 'Slovakia' },
  { value: '+36', zh: '匈牙利', en: 'Hungary' },
  { value: '+40', zh: '罗马尼亚', en: 'Romania' },
  { value: '+359', zh: '保加利亚', en: 'Bulgaria' },
  { value: '+30', zh: '希腊', en: 'Greece' },
  { value: '+385', zh: '克罗地亚', en: 'Croatia' },
  { value: '+386', zh: '斯洛文尼亚', en: 'Slovenia' },
  { value: '+387', zh: '波黑', en: 'Bosnia and Herzegovina' },
  { value: '+381', zh: '塞尔维亚', en: 'Serbia' },
  { value: '+382', zh: '黑山', en: 'Montenegro' },
  { value: '+383', zh: '科索沃', en: 'Kosovo' },
  { value: '+355', zh: '阿尔巴尼亚', en: 'Albania' },
  { value: '+389', zh: '北马其顿', en: 'North Macedonia' },
  { value: '+372', zh: '爱沙尼亚', en: 'Estonia' },
  { value: '+371', zh: '拉脱维亚', en: 'Latvia' },
  { value: '+370', zh: '立陶宛', en: 'Lithuania' },
  { value: '+353', zh: '爱尔兰', en: 'Ireland' },
  { value: '+354', zh: '冰岛', en: 'Iceland' },
  { value: '+352', zh: '卢森堡', en: 'Luxembourg' },
  { value: '+356', zh: '马耳他', en: 'Malta' },
  { value: '+357', zh: '塞浦路斯', en: 'Cyprus' },
  { value: '+90', zh: '土耳其', en: 'Turkey' },
  { value: '+7', zh: '俄罗斯/哈萨克斯坦', en: 'Russia/Kazakhstan' },
  { value: '+375', zh: '白俄罗斯', en: 'Belarus' },
  { value: '+380', zh: '乌克兰', en: 'Ukraine' },
  { value: '+373', zh: '摩尔多瓦', en: 'Moldova' },
  { value: '+374', zh: '亚美尼亚', en: 'Armenia' },
  { value: '+995', zh: '格鲁吉亚', en: 'Georgia' },
  { value: '+994', zh: '阿塞拜疆', en: 'Azerbaijan' },
  { value: '+976', zh: '蒙古', en: 'Mongolia' },

  // 亚洲
  { value: '+81', zh: '日本', en: 'Japan' },
  { value: '+82', zh: '韩国', en: 'South Korea' },
  { value: '+65', zh: '新加坡', en: 'Singapore' },
  { value: '+60', zh: '马来西亚', en: 'Malaysia' },
  { value: '+66', zh: '泰国', en: 'Thailand' },
  { value: '+84', zh: '越南', en: 'Vietnam' },
  { value: '+63', zh: '菲律宾', en: 'Philippines' },
  { value: '+62', zh: '印度尼西亚', en: 'Indonesia' },
  { value: '+91', zh: '印度', en: 'India' },
  { value: '+92', zh: '巴基斯坦', en: 'Pakistan' },
  { value: '+880', zh: '孟加拉', en: 'Bangladesh' },
  { value: '+94', zh: '斯里兰卡', en: 'Sri Lanka' },
  { value: '+95', zh: '缅甸', en: 'Myanmar' },
  { value: '+673', zh: '文莱', en: 'Brunei' },
  { value: '+855', zh: '柬埔寨', en: 'Cambodia' },
  { value: '+856', zh: '老挝', en: 'Laos' },
  { value: '+960', zh: '马尔代夫', en: 'Maldives' },
  { value: '+977', zh: '尼泊尔', en: 'Nepal' },
  { value: '+975', zh: '不丹', en: 'Bhutan' },
  { value: '+93', zh: '阿富汗', en: 'Afghanistan' },
  { value: '+98', zh: '伊朗', en: 'Iran' },
  { value: '+964', zh: '伊拉克', en: 'Iraq' },
  { value: '+962', zh: '约旦', en: 'Jordan' },
  { value: '+961', zh: '黎巴嫩', en: 'Lebanon' },
  { value: '+963', zh: '叙利亚', en: 'Syria' },
  { value: '+970', zh: '巴勒斯坦', en: 'Palestine' },
  { value: '+971', zh: '阿联酋', en: 'United Arab Emirates' },
  { value: '+968', zh: '阿曼', en: 'Oman' },
  { value: '+974', zh: '卡塔尔', en: 'Qatar' },
  { value: '+965', zh: '科威特', en: 'Kuwait' },
  { value: '+966', zh: '沙特阿拉伯', en: 'Saudi Arabia' },
  { value: '+967', zh: '也门', en: 'Yemen' },
  { value: '+972', zh: '以色列', en: 'Israel' },
  { value: '+973', zh: '巴林', en: 'Bahrain' },
  { value: '+996', zh: '吉尔吉斯斯坦', en: 'Kyrgyzstan' },
  { value: '+992', zh: '塔吉克斯坦', en: 'Tajikistan' },
  { value: '+993', zh: '土库曼斯坦', en: 'Turkmenistan' },
  { value: '+998', zh: '乌兹别克斯坦', en: 'Uzbekistan' },
  { value: '+851', zh: '北韩', en: 'North Korea' },

  // 非洲
  { value: '+20', zh: '埃及', en: 'Egypt' },
  { value: '+27', zh: '南非', en: 'South Africa' },
  { value: '+234', zh: '尼日利亚', en: 'Nigeria' },
  { value: '+254', zh: '肯尼亚', en: 'Kenya' },
  { value: '+255', zh: '坦桑尼亚', en: 'Tanzania' },
  { value: '+256', zh: '乌干达', en: 'Uganda' },
  { value: '+251', zh: '埃塞俄比亚', en: 'Ethiopia' },
  { value: '+250', zh: '卢旺达', en: 'Rwanda' },
  { value: '+257', zh: '布隆迪', en: 'Burundi' },
  { value: '+253', zh: '吉布提', en: 'Djibouti' },
  { value: '+252', zh: '索马里', en: 'Somalia' },
  { value: '+211', zh: '南苏丹', en: 'South Sudan' },
  { value: '+249', zh: '苏丹', en: 'Sudan' },
  { value: '+243', zh: '刚果(金)', en: 'DR Congo' },
  { value: '+242', zh: '刚果(布)', en: 'Republic of Congo' },
  { value: '+241', zh: '加蓬', en: 'Gabon' },
  { value: '+240', zh: '赤道几内亚', en: 'Equatorial Guinea' },
  { value: '+237', zh: '喀麦隆', en: 'Cameroon' },
  { value: '+235', zh: '乍得', en: 'Chad' },
  { value: '+236', zh: '中非', en: 'Central African Republic' },
  { value: '+239', zh: '圣多美和普林西比', en: 'Sao Tome and Principe' },
  { value: '+238', zh: '佛得角', en: 'Cape Verde' },
  { value: '+245', zh: '几内亚比绍', en: 'Guinea-Bissau' },
  { value: '+244', zh: '安哥拉', en: 'Angola' },
  { value: '+267', zh: '博茨瓦纳', en: 'Botswana' },
  { value: '+266', zh: '莱索托', en: 'Lesotho' },
  { value: '+263', zh: '津巴布韦', en: 'Zimbabwe' },
  { value: '+260', zh: '赞比亚', en: 'Zambia' },
  { value: '+265', zh: '马拉维', en: 'Malawi' },
  { value: '+261', zh: '马达加斯加', en: 'Madagascar' },
  { value: '+230', zh: '毛里求斯', en: 'Mauritius' },
  { value: '+269', zh: '科摩罗', en: 'Comoros' },
  { value: '+248', zh: '塞舌尔', en: 'Seychelles' },
  { value: '+222', zh: '毛里塔尼亚', en: 'Mauritania' },
  { value: '+221', zh: '塞内加尔', en: 'Senegal' },
  { value: '+220', zh: '冈比亚', en: 'Gambia' },
  { value: '+224', zh: '几内亚', en: 'Guinea' },
  { value: '+225', zh: '科特迪瓦', en: "Cote d'Ivoire" },
  { value: '+226', zh: '布基纳法索', en: 'Burkina Faso' },
  { value: '+227', zh: '尼日尔', en: 'Niger' },
  { value: '+228', zh: '多哥', en: 'Togo' },
  { value: '+229', zh: '贝宁', en: 'Benin' },
  { value: '+233', zh: '加纳', en: 'Ghana' },
  { value: '+231', zh: '利比里亚', en: 'Liberia' },
  { value: '+232', zh: '塞拉利昂', en: 'Sierra Leone' },
  { value: '+223', zh: '马里', en: 'Mali' },
  { value: '+212', zh: '摩洛哥', en: 'Morocco' },
  { value: '+213', zh: '阿尔及利亚', en: 'Algeria' },
  { value: '+216', zh: '突尼斯', en: 'Tunisia' },
  { value: '+218', zh: '利比亚', en: 'Libya' },

  // 大洋洲
  { value: '+61', zh: '澳大利亚', en: 'Australia' },
  { value: '+64', zh: '新西兰', en: 'New Zealand' },
  { value: '+679', zh: '斐济', en: 'Fiji' },
  { value: '+677', zh: '所罗门群岛', en: 'Solomon Islands' },
  { value: '+676', zh: '汤加', en: 'Tonga' },
  { value: '+675', zh: '巴布亚新几内亚', en: 'Papua New Guinea' },
  { value: '+674', zh: '瑙鲁', en: 'Nauru' },
  { value: '+692', zh: '马绍尔群岛', en: 'Marshall Islands' },
  { value: '+691', zh: '密克罗尼西亚', en: 'Micronesia' },
  { value: '+690', zh: '托克劳', en: 'Tokelau' },
  { value: '+689', zh: '法属波利尼西亚', en: 'French Polynesia' },
  { value: '+687', zh: '新喀里多尼亚', en: 'New Caledonia' },
  { value: '+686', zh: '基里巴斯', en: 'Kiribati' },
  { value: '+685', zh: '萨摩亚', en: 'Samoa' },
  { value: '+684', zh: '美属萨摩亚', en: 'American Samoa' },
  { value: '+683', zh: '纽埃', en: 'Niue' },
  { value: '+682', zh: '库克群岛', en: 'Cook Islands' },
  { value: '+681', zh: '瓦利斯和富图纳', en: 'Wallis and Futuna' },
  { value: '+678', zh: '瓦努阿图', en: 'Vanuatu' },
];
